import { cva, type VariantProps } from 'class-variance-authority'

export { default as CupraHeading } from './CupraHeading.vue'

export const headingVariants = cva('uppercase font-light', {
    variants: {
        variant: {
            1: 'text-3xl md:text-5xl',
            2: 'text-2xl md:text-4xl',
            3: 'text-xl md:text-2xl',
            4: 'text-lg md:text-xl',
        },
    },
    defaultVariants: {
        variant: 1,
    },
})

export type HeadingVariants = VariantProps<typeof headingVariants>
